// extracted by mini-css-extract-plugin
module.exports = {"root":"carousel-pagination_root__6CbVe"};